var messaging;

try {
    var firebaseConfig = {
        apiKey: "AIzaSyC25eGwK7g2Ams-o7uKhDiozr5-0AYHWoo",
        authDomain: "chocolate-326916.firebaseapp.com",
        projectId: "chocolate-326916",
        storageBucket: "chocolate-326916.appspot.com",
        messagingSenderId: "327192288334",
        appId: "1:327192288334:web:2d41f4dbc7155fd1ff371f",
        measurementId: "G-H5T1E0YX8H",
    };
    firebase.initializeApp(firebaseConfig);
    messaging = firebase.messaging();
    navigator.serviceWorker.register('firebase-messaging-sw.js', {scope: "firebase-cloud-messaging-push-scope"})
      .then((registration) => {
          const messaging = firebase.messaging();
          messaging.useServiceWorker(registration);

      }).catch(err => {
          console.log(err)
      })

      messaging.onMessage(function (payload) {
        const noteTitle = payload.notification.title;
        const noteOptions = {
            body: payload.notification.body,
            icon: payload.notification.icon,
        };
        new Notification(noteTitle, noteOptions);

        console.log("Firebase message", payload);
    });

} catch(error) {}

export {messaging};
